export default function SectionHeading({ overline, title, description, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {overline && (
        <div className={`overline text-terracotta mb-4 ${align === "center" ? "" : ""}`}>
          {overline}
        </div>
      )}
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium text-ink leading-[1.05] tracking-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-6 text-base md:text-lg text-muted2 leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}
